import { Create, getValueFromEvent, useFileUploadState, useForm } from "@refinedev/antd";
import { FileTextOutlined, InboxOutlined } from "@ant-design/icons";
import { Form, Input, Tag, Upload, Space } from "antd";
import { IResourceComponentsProps, useApiUrl } from "@refinedev/core";

import { IDigitalPublication } from "interfaces";
import { FormSection, FormFieldGrid } from "components/form";
import React from "react";

import { uploadDigitalPublicationViaSignedUrl } from "./uploadViaSignedUrl";

export const DigitalPublicationCreate: React.FC<
  IResourceComponentsProps
> = () => {
  const [isFileUploaded, setIsFileUploaded] = React.useState(false);

  const {
    formProps,
    saveButtonProps,
    formLoading: isLoading,
  } = useForm<IDigitalPublication>({ redirect: "list" });

  const { onChange, isLoading: isFileUploading } = useFileUploadState();
  const apiUrl = useApiUrl();

  function onFileUpload(e: any) {
    setIsFileUploaded(true);
    onChange(e);
  }

  const props = {
    name: "file",
    multiple: false,
    maxCount: 1,
    // Cloud Run caps request bodies at 32 MiB, so upload goes direct to GCS
    customRequest: async ({ file, onSuccess, onError }: any) => {
      try {
        const response = await uploadDigitalPublicationViaSignedUrl(
          apiUrl,
          file
        );
        onSuccess?.(response);
      } catch (error) {
        onError?.(error);
      }
    },
    onChange: onFileUpload,
  };

  return (
    <Create
      breadcrumb={false}
      saveButtonProps={{
        ...saveButtonProps,
        disabled: isFileUploaded && !isFileUploading ? false : true,
      }}
      headerProps={{
        onBack: () => window.history.back(),
        title: "Digital Bookshelf",
        subTitle: "electronic digital publications",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
    >
      <Form {...formProps} layout="vertical" initialValues={{}}>
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
          <FormSection
            title="Publication Details"
            subtitle="Digital publication information"
            icon={<FileTextOutlined />}
            variant="elevated"
          >
            <FormFieldGrid columns={2}>
              <Form.Item
                label="Title"
                name={["title"]}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input name="title" />
              </Form.Item>
              <Form.Item
                label="EDP Number"
                name={["edpNumber"]}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input name="edpNumber" />
              </Form.Item>
              <Form.Item
                label="Current Edition"
                name={["currentEdition"]}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input name="edpNumber" />
              </Form.Item>
            </FormFieldGrid>
          </FormSection>
          <FormSection
            title="File Upload"
            subtitle="Upload digital publication file"
            icon={<FileTextOutlined />}
            variant="elevated"
          >
            <Form.Item
              label="File"
              name="file"
              valuePropName="file"
              getValueFromEvent={getValueFromEvent}
            >
              <Upload.Dragger {...props} listType="picture">
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag & drop file to this area to upload
                </p>
                <p className="ant-upload-hint">
                  Support for a single upload of electronic digital publication
                  for vessel
                </p>
              </Upload.Dragger>
            </Form.Item>
          </FormSection>
        </Space>
      </Form>
    </Create>
  );
};
